// /* istanbul ignore file */
import Icon_accountCircle from "../../assets/icons/accountCircle.svg";
import Icon_activate from "../../assets/icons/activate.svg";
import Icon_angleDown from "../../assets/icons/angleDown.svg";
import Icon_apartment from "../../assets/icons/apartment.svg";
import Icon_arrowDown from "../../assets/icons/arrowDown.svg";
import Icon_arrowDownward from "../../assets/icons/arrowDownward.svg";
import Icon_arrowLeft from "../../assets/icons/arrowLeft.svg";
import Icon_arrowRight from "../../assets/icons/arrowRight.svg";
import Icon_arrowRightTop from "../../assets/icons/arrowRightTop.svg";
import Icon_avatar1 from "../../assets/icons/avatar1.svg";
import Icon_avatar2 from "../../assets/icons/avatar2.svg";
import Icon_avatar3 from "../../assets/icons/avatar3.svg";
import Icon_avatar4 from "../../assets/icons/avatar4.svg";
import Icon_avatar1New from "../../assets/icons/avatarNew.svg";
import Icon_avatar2New from "../../assets/icons/avatar2New.svg";
import Icon_avatar3New from "../../assets/icons/avatar3New.svg";
import Icon_avatar4New from "../../assets/icons/avatar4New.svg";
import Icon_bank from "../../assets/icons/bank.svg";
import Icon_bellOutline from "../../assets/icons/bellOutline.svg";
import Icon_calendarClock from "../../assets/icons/calendarClock.svg";
import Icon_chartUp from "../../assets/icons/chartUp.svg";
import Icon_check from "../../assets/icons/check.svg";
import Icon_checkCircle from "../../assets/icons/checkCircle.svg";
import Icon_checkmarkBullet from "../../assets/icons/checkmarkBullet.svg";
import Icon_checkThick from "../../assets/icons/checkThick.svg";
import Icon_close from "../../assets/icons/close.svg";
import Icon_closeThick from "../../assets/icons/closeThick.svg";
import Icon_company from "../../assets/icons/company.svg";
import Icon_contractEdit from "../../assets/icons/contractEdit.svg";
import Icon_dash from "../../assets/icons/dash.svg";
import Icon_deactivate from "../../assets/icons/deactivate.svg";
import Icon_delete from "../../assets/icons/delete.svg";
import Icon_document from "../../assets/icons/document.svg";
import Icon_documents from "../../assets/icons/documents.svg";
import Icon_edit from "../../assets/icons/edit.svg";
import Icon_editUnderline from "../../assets/icons/editUnderline.svg";
import Icon_electricity from "../../assets/icons/electricity.svg";
import Icon_energy from "../../assets/icons/energy.svg";
import Icon_errorOutline from "../../assets/icons/errorOutline.svg";
import Icon_euro from "../../assets/icons/euro.svg";
import Icon_exclamationInfo from "../../assets/icons/exclamationInfo.svg";
import Icon_gas from "../../assets/icons/gas.svg";
import Icon_globe from "../../assets/icons/globe.svg";
import Icon_greencheckCircle from "../../assets/icons/greencheckCircle.svg";
import Icon_helpOutline from "../../assets/icons/helpOutline.svg";
import Icon_history from "../../assets/icons/history.svg";
import Icon_historyAlt from "../../assets/icons/historyAlt.svg";
import Icon_house from "../../assets/icons/house.svg";
import Icon_infoIconPlain from "../../assets/icons/info.svg";
import Icon_infoIconCircle from "../../assets/icons/infoCircle.svg";
import Icon_letter from "../../assets/icons/letter.svg";
import Icon_location from "../../assets/icons/location.svg";
import Icon_lock from "../../assets/icons/lock.svg";
import Icon_mail from "../../assets/icons/mail.svg";
import Icon_mailSent from "../../assets/icons/mailSent.svg";
import Icon_menu from "../../assets/icons/menu.svg";
import Icon_menuDots from "../../assets/icons/menuDots.svg";
import Icon_person from "../../assets/icons/person.svg";
import Icon_personAdd from "../../assets/icons/personAdd.svg";
import Icon_phone from "../../assets/icons/phone.svg";
import Icon_piggyBank from "../../assets/icons/piggyBank.svg";
import Icon_planeClock from "../../assets/icons/planeClock.svg";
import Icon_play from "../../assets/icons/playIcon.svg";
import Icon_quote from "../../assets/icons/quote.svg";
import Icon_redo from "../../assets/icons/redo.svg";
import Icon_refresh from "../../assets/icons/refresh.svg";
import Icon_shield from "../../assets/icons/shield.svg";
import Icon_stars from "../../assets/icons/stars.svg";
import Icon_sun from "../../assets/icons/sun.svg";
import Icon_supportAgent from "../../assets/icons/supportAgent.svg";
import Icon_sync from "../../assets/icons/sync.svg";
import Icon_syncDisabled from "../../assets/icons/syncDisabled.svg";
import Icon_truck from "../../assets/icons/truck.svg";
import Icon_turningArrows from "../../assets/icons/checkInLoop.svg";
import Icon_verified from "../../assets/icons/verified.svg";
import Icon_visibility from "../../assets/icons/visibility.svg";
import Icon_warning from "../../assets/icons/warning.svg";
import Icon_whatsapp from "../../assets/icons/whatsapp.svg";
import Icon_checkCircleFilled from "../../assets/icons/checkCircleFilled.svg";
import Icon_contract from "../../assets/icons/contract.svg";
import Icon_contractEdit2 from "../../assets/icons/contractEdit2.svg";
import Icon_location2 from "../../assets/icons/location2.svg";
import Icon_energySaving from "../../assets/icons/energySaving.svg";
import Icon_energySavingGreen from "../../assets/icons/energySavingGreen.svg";
import Icon_homeWork from "../../assets/icons/homeWork.svg";
import Icon_calendarMonth from "../../assets/icons/calendarMonth.svg";
import Icon_demography from "../../assets/icons/demography.svg";
import Icon_youtube from "../../assets/icons/youtube.svg";
import Icon_tiktok from "../../assets/icons/tiktok.svg";
import Icon_instagram from "../../assets/icons/instagram.svg";
import Icon_facebook from "../../assets/icons/facebook.svg";
import Icon_backArrow from "../../assets/icons/backArrow.svg";
import Icon_eye from "../../assets/icons/eye.svg";
import Icon_eyeCross from "../../assets/icons/eyeCross.svg";
import Icon_heatpump from "../../assets/icons/heatpump.svg";
import Icon_heatpump2 from "../../assets/icons/heatpump2.svg";
import Icon_heatpumpSmall from "../../assets/icons/heatpumpSmall.svg";
import Icon_aptNew from "../../assets/icons/aptNew.svg";
import Icon_companyNew from "../../assets/icons/companyNew.svg";
import Icon_electricityNew from "../../assets/icons/electricityNew.svg";
import Icon_gasNew from "../../assets/icons/gasNew.svg";
import Icon_houseNew from "../../assets/icons/houseNew.svg";
import Icon_radioChecked from "../../assets/icons/radioChecked.svg";
import Icon_radioUnChecked from "../../assets/icons/radioUnChecked.svg";
import Icon_gift from "../../assets/icons/gift.svg";
import Icon_giftMobile from "../../assets/icons/giftMobile.svg";

export default {
  Icon_eye,
  Icon_eyeCross,
  Icon_backArrow,
  Icon_youtube,
  Icon_instagram,
  Icon_tiktok,
  Icon_facebook,
  Icon_accountCircle,
  Icon_activate,
  Icon_angleDown,
  Icon_apartment,
  Icon_arrowDown,
  Icon_arrowDownward,
  Icon_arrowLeft,
  Icon_arrowRight,
  Icon_arrowRightTop,
  Icon_avatar1,
  Icon_avatar2,
  Icon_avatar3,
  Icon_avatar4,
  Icon_avatar1New,
  Icon_avatar2New,
  Icon_avatar3New,
  Icon_avatar4New,
  Icon_bank,
  Icon_bellOutline,
  Icon_calendarClock,
  Icon_chartUp,
  Icon_check,
  Icon_checkCircle,
  Icon_checkCircleFilled,
  Icon_checkmarkBullet,
  Icon_checkThick,
  Icon_close,
  Icon_closeThick,
  Icon_company,
  Icon_contract,
  Icon_contractEdit,
  Icon_contractEdit2,
  Icon_dash,
  Icon_deactivate,
  Icon_delete,
  Icon_document,
  Icon_documents,
  Icon_edit,
  Icon_editUnderline,
  Icon_electricity,
  Icon_energy,
  Icon_errorOutline,
  Icon_euro,
  Icon_exclamationInfo,
  Icon_gas,
  Icon_globe,
  Icon_greencheckCircle,
  Icon_helpOutline,
  Icon_history,
  Icon_historyAlt,
  Icon_house,
  Icon_infoIconPlain,
  Icon_infoIconCircle,
  Icon_letter,
  Icon_location,
  Icon_location2,
  Icon_lock,
  Icon_mail,
  Icon_mailSent,
  Icon_menu,
  Icon_menuDots,
  Icon_person,
  Icon_personAdd,
  Icon_phone,
  Icon_piggyBank,
  Icon_planeClock,
  Icon_play,
  Icon_quote,
  Icon_redo,
  Icon_refresh,
  Icon_shield,
  Icon_stars,
  Icon_sun,
  Icon_supportAgent,
  Icon_sync,
  Icon_syncDisabled,
  Icon_truck,
  Icon_turningArrows,
  Icon_verified,
  Icon_visibility,
  Icon_warning,
  Icon_whatsapp,
  Icon_energySaving,
  Icon_energySavingGreen,
  Icon_homeWork,
  Icon_calendarMonth,
  Icon_demography,
  Icon_heatpump,
  Icon_heatpump2,
  Icon_heatpumpSmall,
  Icon_companyNew,
  Icon_electricityNew,
  Icon_gasNew,
  Icon_houseNew,
  Icon_aptNew,
  Icon_radioChecked,
  Icon_radioUnChecked,
  Icon_gift,
  Icon_giftMobile,
};
